export default __webpack_public_path__ + "static/troop-cup-banner-43f99ae87fa50459545adccc358516d5.png";